import React from "react";
import ReactDOM from "react-dom/client"; // React 18 için uygun modül
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";

// React 18'de createRoot kullanımı
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
